import React, { Component } from 'react'
import { XCircleIcon } from '@heroicons/react/solid'
import ButtonPrevious from '../UI/ButtonPrevious'

class SubscribeStepConfirmEmail extends Component {
	constructor(props) {
		super(props)
		this.state = {
			email: '',
			error: null,
			loading: false
		}
	}

	isValid = () => {
		const { email } = this.state
		return email.includes('@') && email.includes('.') && email.length > 5
	}

	handleSubmit = (event) => {
		event.preventDefault()
		if (!this.isValid()) {
			this.setState({ error: this.props.lang_assets.subscribe.confirm_email.errors.invalid_email })
			return
		}
		this.setState({ loading: true, error: null })
		this.props.onSubmit(this.state.email.trim().toLowerCase())
		.then(error => {
			if (error)
				this.setState({ loading: false, error: error })
			// Si null → le parent gère la navigation
		})
		.catch(() => {
			this.setState({ loading: false, error: this.props.lang_assets.subscribe.confirm_email.errors.general_error })
		})
	}

	render() {
		const lang = this.props.lang_assets.subscribe.confirm_email
		const themeColor = '#' + this.props.theme.color1
		const btnColor = this.isValid() ? themeColor : '#A3A3A3'

		return (
			<div>
				<ButtonPrevious
					theme={this.props.theme}
					handlePreviousBtn={this.props.handlePreviousBtn}
				/>
				<div style={{ backgroundColor: themeColor }} className="h-52 z-0 px-8 text-center">
					<p className="text-2xl text-white pt-14 mt-0">{lang.confirmation}</p>
					<h1 className="text-3xl text-white font-semibold m-0 pt-2">{lang.title}</h1>
				</div>
				<div className="rounded-t-3xl z-10" style={{ backgroundColor: "#ffffff", marginTop: "-2rem" }}>
					<div className="px-10 pt-12 pb-10">
						<p className="text-gray-500 text-base mb-2">
							{lang.help_text}
						</p>
						{this.props.emailMasked && (
							<p className="text-base font-semibold mb-8" style={{ color: themeColor }}>
								{this.props.emailMasked}
							</p>
						)}
						<form onSubmit={this.handleSubmit}>
							<div className="mb-8">
								<label className="block text-sm font-medium text-gray-500 mb-1">{lang.email_label}</label>
								<div className="border-b border-gray-300 focus-within:border-blue-500">
									<input
										className="block pl-0 w-full border-0 border-transparent text-gray-700 focus:ring-0 text-xl"
										type="email"
										value={this.state.email}
										onChange={(e) => this.setState({ email: e.target.value, error: null })}
										autoCapitalize="none"
										autoComplete="email"
									/>
								</div>
							</div>
							{this.state.error && (
								<div className="rounded-md bg-red-50 p-4 mb-4">
									<div className="flex">
										<div className="flex-shrink-0">
											<XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true" />
										</div>
										<div className="ml-3">
											<h3 className="text-sm font-medium text-red-800">{this.state.error}</h3>
										</div>
									</div>
								</div>
							)}
							<button
								className="items-center px-6 py-5 border border-transparent text-xl font-medium rounded-full w-full shadow-sm text-white my-6"
								type="submit"
								disabled={this.state.loading || !this.isValid()}
								style={{ backgroundColor: btnColor }}
							>
								{this.state.loading ? lang.verifying : lang.button}
							</button>
							{this.props.onUseActivationCode && (
								<p className="text-center text-sm text-gray-400 mt-2">
									{lang.no_email_msg}{' '}
									<button
										type="button"
										onClick={this.props.onUseActivationCode}
										className="font-medium underline"
										style={{ color: themeColor }}
									>
										{lang.use_activation_code}
									</button>
								</p>
							)}
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default SubscribeStepConfirmEmail
